module.exports = __webpack_public_path__ + "img/final-price.275b4083.png";